export default __webpack_public_path__ + "static/media/reason03.191d3c02.jpg";